import {
  FETCH_ITEM_LOCATION_LISTING_FAILURE,
  FETCH_ITEM_LOCATION_LISTING_SUCCESS
} from "./itemLocationTypes";
import {
  setLoaderRequestTrue,
  setLoaderRequestFalse,
} from "../common/commonAction";
import { GetApiActionWithAuthorization } from "../../constantFunctions/apiActions";

/*_________________________________________________________________Booth Listing __________________________________________________________________ */

//Api Call Function for item location listing
export const fetchItemLocationListing = (params = {}) => {
  return (dispatch) => {
    dispatch(setLoaderRequestTrue());
    dispatch(fetchItemLocationListingSuccess([]));
    GetApiActionWithAuthorization("common/get-all-item-locations", params)
      .then((res) => {
        dispatch(setLoaderRequestFalse());
        dispatch(fetchItemLocationListingSuccess(res.data));
      })
      .catch((err) => {
        dispatch(setLoaderRequestFalse());
        dispatch(fetchItemLocationListingFailure(err));
      });
  };
};

//Item location listing Success save Payload data to store
export const fetchItemLocationListingSuccess = (data) => {
  return {
    type: FETCH_ITEM_LOCATION_LISTING_SUCCESS,
    payload: data,
  };
};

//Item location listing Failure save Payload
export const fetchItemLocationListingFailure = (error) => {
  return {
    type: FETCH_ITEM_LOCATION_LISTING_FAILURE,
    payload: error,
  };
};
/*__________________________________________________________________________________________________________________________________________ */
